import { classNames } from 'libs/react';
import { Badge } from 'components/Badge';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { GlobalSearchField } from 'components/search/GlobalSearchField';
import { useGlobalSearchEnabled } from 'components/search/GlobalSearchProvider';
import 'components/NavigationBar.scss';
/**
 * @component NavigationBar
 * @since 1.0.0
 */
export function NavigationBar(props) {
    var _a, _b;
    const { style, picto, title, back, count, crumbs } = Object.assign({ style: 'normal' }, props);
    const search = useGlobalSearchEnabled();
    /*
     * Locals, not defaults written onto the prop: the object came from the
     * caller and mutating it is a side effect on someone else's data.
     */
    const backPicto = (_a = back === null || back === void 0 ? void 0 : back.picto) !== null && _a !== void 0 ? _a : 'arrow-left';
    const backLabel = (_b = back === null || back === void 0 ? void 0 : back.label) !== null && _b !== void 0 ? _b : 'Back';
    const className = classNames('navigation-bar', 'navigation-bar--' + style, { 'navigation-bar--has-picto': picto }, { 'navigation-bar--has-title': title }, { 'navigation-bar--has-back': back }, 
    // The three zones are only balanced when there is a centre to balance.
    { 'navigation-bar--has-search': search }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "navigation-bar-start" },
            back && (React.createElement("nav", { className: "navigation-bar-head", "aria-label": t('Breadcrumb') }, crumbs === null || crumbs === void 0 ? void 0 :
                crumbs.map((crumb, index) => (React.createElement(React.Fragment, { key: index },
                    React.createElement(Link, { className: "navigation-bar-crumb", route: crumb.route },
                        React.createElement(Text, { className: "navigation-bar-crumb-label", value: crumb.label })),
                    React.createElement(Icon, { className: "navigation-bar-crumb-separator", value: "chevron-right" })))),
                React.createElement(Link, { className: "navigation-bar-back", route: back.route },
                    React.createElement(Icon, { className: "navigation-bar-back-picto", value: backPicto }),
                    React.createElement(Text, { className: "navigation-bar-back-label", value: backLabel })))),
            React.createElement("div", { className: "navigation-bar-body" },
                picto && React.createElement(Icon, { className: "navigation-bar-picto", value: picto }),
                title && (React.createElement(Text, { className: "navigation-bar-title", value: title, ellipsize: true })),
                count != null && count >= 0 && (React.createElement(Badge, { className: "navigation-bar-count", label: count })))),
        search && (React.createElement("div", { className: "navigation-bar-search", role: "search" },
            React.createElement(GlobalSearchField, null))),
        React.createElement("div", { className: "navigation-bar-foot" }, props.children)));
}
